// Parent mode's clock (WI-17), mounted once for the whole shell. It owns the 1-second tick, so the
// rest of the shell doesn't re-render with it, and publishes what the Map's trip pill needs
// (app/StatusBits `TripPill`): while parent mode is on, that pill becomes "Parent mode · N min ·
// Done", yellow in the last minute. While a sheet or the plan is open the clock is paused (Settings
// has its own parent-mode row with Done).
import { useEffect } from 'react'
import { create } from 'zustand'
import { useParentMode } from './useParentMode'

export interface ParentModePill {
  minutesLeft: number
  warn: boolean
  /** The child whose phone this is. */
  child: string
}

/** Parent mode as the pill shows it, or null when this isn't parent mode. */
export const useParentModePill = create<{ pill: ParentModePill | null }>(() => ({ pill: null }))

export function ParentModeClock({ paused }: { paused: boolean }) {
  const mode = useParentMode(paused)
  const on = !!mode
  const minutesLeft = mode?.minutesLeft ?? 0
  const warn = mode?.warn ?? false
  const child = mode?.child ?? ''
  // Only when what the pill shows changes, not on every tick.
  useEffect(() => {
    useParentModePill.setState({ pill: on ? { minutesLeft, warn, child } : null })
  }, [on, minutesLeft, warn, child])
  useEffect(() => () => useParentModePill.setState({ pill: null }), [])
  return null
}
